import React, { useState, useMemo, useEffect } from "react";
import HeaderComponents from "../../components/HeaderComponents";
import "../../utils/Style/pages/Overview.scss";
import AccountsSection from "../../components/Overview/AccountsSection";
import OverviewAccountSkeleton from "../../components/skeletons/OverviewAccountSkeleton";
import OverviewSection from "../../components/Overview/OverviewSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowDown, faMagnifyingGlass, faPlay} from "@fortawesome/free-solid-svg-icons";
import { useSortBy, useTable } from "react-table";
import Table from "../../components/Table";
import { capitalizeFirstLetters } from "../../features/ValueFormater";
import "../../utils/Style/pages/NewOrder.scss"
import useDeliveryOrderApi from "../../api/DelivaryOrderApi";
import DatePicker from "../../components/DatePicker";
import TransferListSkeleton from "../../components/skeletons/TransferListSkeleton";
import UtcToLocal from "../../components/UtcToLocal";
import useOrderProcessingApi from "../../api/OrderProcessingApi";
import { useDispatch } from "react-redux";
import { setActionPayload, setActionType } from "../../features/authorizationSlice";
import { ACTION_TYPES } from "../../app/actionTypes";
import { useOutletContext } from "react-router-dom";
import Pagination from "../../components/Pagination";
import RecordsMessage from "../../components/RecordsMessage";

function NewOrder({method}) {
    const [loading, setLoading] = useState(false);
    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedPage, setSelectedPage] = useState(1);
    const [month, setMonth] = useState("ThisMonth");
    const [orders, setOrders] = useState([]);
    const [selectedOrderType, setSelectedOrderType] = useState("");
    const dispatch = useDispatch();

    const [ onOpenQrAfterGenerate ]  = useOutletContext();

    const { GetNewOrders, newOrders, newOrdersLoading, totalNbOfPage, totalCount } = useDeliveryOrderApi();
    const { GetOrderTypes, orderTypes } = useOrderProcessingApi();

    useEffect(() => {
        GetOrderTypes();
    }, [])

    useEffect(() => {
        if (orderTypes) {
            setOrders(orderTypes);
        }
    }, [orderTypes]);
    

    const [dateRange, setDateRange] = useState([
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
    ]);

    const [dateString, setDateString] = useState({
        startDateString: "",
        endDateString: ""
    });

    useEffect(() => {
        if (dateRange && dateRange.length === 2) {
            const [start] = dateRange;
            const end = new Date();
    
            if (start && !isNaN(start) && !isNaN(end)) {
                const startDate = new Date(Date.UTC(start.getUTCFullYear() - 1, start.getUTCMonth(), start.getUTCDate()));
                const endDate = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate()));
                
                const startDateString = startDate.toISOString().substring(0, 10);
                const endDateString = endDate.toISOString().substring(0, 10);
                
                setDateString({
                    startDateString,
                    endDateString
                });
    
                GetNewOrders(1, startDateString, endDateString, "");
            }
        }
    }, [dateRange]);
    
    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const handleCancel = (orderId) => {
        const payload = {
            orderId: orderId
        };
        dispatch(setActionType(ACTION_TYPES.CANCEL_ORDER));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate(); 
    };
    

    const columns = useMemo(() => [
        {
            Header: "Order ID",
            accessor: "orderID",
        },
        {
            Header: "Type",
            accessor: "type",
            Cell: ({ row, value }) => {
                const type = row.original.type;
                if ( type === "Withdraw") {
                    return (
                        <div>
                            <img src="/Images/triangle.svg" className="triangle-icon" alt="Triangle Icon" />
                            {value}
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <img src="/Images/reverse-triangle.svg" className="triangle-icon" alt="Triangle Icon" />
                            {value}
                        </div>
                    )
                }
             
            }
          },
          {
            Header: "",
            accessor: "details",
            Cell: ({ row }) => (
                <button className="showmore" onClick={() => setActiveRowIndex(row.index)}>
                    <FontAwesomeIcon icon={faArrowDown} />
                </button>
            ),
        },
        {
            Header: "User ID",
            accessor: "userID",
        },
        {
            Header: "Currency",
            accessor: "currency",
        },
        {
            Header: "Amount ($)",
            accessor: "amount",
            Cell: ({ cell: { value } }) => {
                return (
                  <div style={{ fontFamily: "Poppins SemiBold" }}>
                    ${value}
                  </div>
                );
              }
        },
        {
            Header: "Date",
            accessor: "date",
            Cell: ({cell: {value}}) => {
                return <UtcToLocal utcTimestamp={value} options={options}/>
            },
        },
        {
            Header: "Time",
            id: "time",
            accessor: "date", 
            Cell: ({ cell: { value } }) => {
                const date = new Date(value);
                return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); 
            },
        },
        {
            Header: "Status",
            accessor: "status",
            Cell: ({ cell: {value}}) => {
                if (["new", "out of delivery", "canceled by client", ].includes(value.toLowerCase())) {
                    return <div className={"status " + value?.toUpperCase()}>{capitalizeFirstLetters(value)}</div>
                }
              }
        },
        {
            Header: "",
            accessor: "others",
            // Cell: ({ row }) => {
            //     return (
            //         <button className="cancel-btn" onClick={() => handleCancel(row.original.orderID)}>
            //             Cancel
            //         </button>
            //     )
            // }
        },
    ], []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data: newOrders }, useSortBy);
    

    const filteredRows = rows.filter((row) => {
        const orderTypeMatch = selectedOrderType === "" || row.original.type === selectedOrderType;
        const searchQueryMatch = Object.values(row.original).some((cellValue) => 
            cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase())
        );
        return orderTypeMatch && searchQueryMatch;
    });

    return (
        <>
        <HeaderComponents title="New Orders" />      
            <div className="NewOrderPage">
                                           
                    {                  
                        newOrdersLoading ? (
                            <TransferListSkeleton />
                        ) : (
                            <div className="NewOrderPageContainer">
                                <div className="table-container">
                                    <div className="tableTop">
                                        <RecordsMessage 
                                            totalCount={totalCount} 
                                            selectedPage={selectedPage} 
                                            records="transactions"
                                        />
                                        <div className="filtering">
                                            <DatePicker
                                                value={dateRange}
                                                onChange={setDateRange}
                                            />
                                            <div className="filteringSearch">
                                                <input
                                                    className="search"
                                                    placeholder="Search"
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)} 
                                                />
                                                <span className="iconSearch">
                                                    <FontAwesomeIcon icon={faMagnifyingGlass}/>
                                                </span>
                                            </div>
                                            {/* <select
                                                className="ddselect"
                                                name="month"
                                                id="month"
                                                onChange={(e) => setMonth(e.target.value)}
                                            >
                                                <option value="ThisMonth">This Month</option>
                                                <option value="LastMonth">Last Month</option>
                                                <option value="LastThreeMonths">Last Three Months</option>
                                            </select> */}
                                            <select
                                                className="ddselect"
                                                name="order"
                                                id="order"
                                                value={selectedOrderType}
                                                onChange={(e) => setSelectedOrderType(e.target.value)}
                                            >
                                                <option value="">All Orders</option>
                                                {orders.map(order => (
                                                    <option key={order.value} value={order.value}>
                                                        {order.label}
                                                    </option>
                                                ))}
                                            </select>            
                                        </div>
                                    </div>
                                    <div className={activeRowIndex === -1 ? "col-12" : "col-8"}>
                                        <Table
                                            headerGroups={headerGroups}
                                            page={filteredRows}
                                            prepareRow={prepareRow}
                                            getTableProps={getTableProps}
                                            getTableBodyProps={getTableBodyProps}
                                            activeRowIndex={activeRowIndex}
                                            setActiveRowIndex={setActiveRowIndex}
                                            sort={true}
                                        /> 
                                        <Pagination
                                        getData={GetNewOrders}
                                        totalNbPage={totalNbOfPage}
                                        method="newOrders"
                                        case={method}
                                        startDateString={dateString.startDateString}
                                        endDateString={dateString.endDateString}
                                        selectedPage={selectedPage}
                                        setSelectedPage={setSelectedPage}
                                        // type={type}
                                        // typeId={typeId}
                                    />
                                    </div>
                                </div>
                            </div>
                        )
                    }
            </div>
    </>
)
};

export default NewOrder;
